export const ContextHeight = 70;
export const MobileMenuHeight = 70;
export const MenuWidth = 300;
